export default "__VITE_ASSET__I_bE1Kys__"